import React from 'react'
import PropTypes from 'prop-types'

import { TableRow, TableRowColumn } from 'material-ui/Table'

import AddLineItem from './AddLineItem'
import JobModuleBase from '../JobModuleBase'
import TimeFormatter from 'infra/TimeFormatter'

export default class LineItem extends JobModuleBase {

  static propTypes = {
    jobInfo: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    itemAllocations: PropTypes.object,
    index: PropTypes.number.isRequired,
    onItemEdited: PropTypes.func.isRequired,
    onItemDelete: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      edit: false
    }
  }

  handleNameClicked = (event) => {
    event.preventDefault()
    this.setState({
      edit: true
    })
  }

  handleAddCancelled = () => {
    this.setState({
      edit: false
    })
  }

  handleItemEdited = (newValues) => {
    this.props.onItemEdited(this.props.item, newValues)
    this.setState({
      edit: false
    })
  }

  handleItemDelete = () => {
    this.props.onItemDelete(this.props.item)
  }

  getProgress = () => {
    let foremansTotal = 0, laborersTotal = 0
    if (this.props.itemAllocations) {
      const workersList = this.props.jobInfo.modules.workers.list
      // Compute overall progress for workers (check if they are set as foremans or not)
      if (workersList) {
        for (const workerId in workersList) {
          const worker = workersList[workerId]
          const workerAllocation = this.props.itemAllocations[workerId]
          if (workerAllocation && workerAllocation.timeInMinutes) {
            if (worker.isForeman) {
              foremansTotal += workerAllocation.timeInMinutes
            }
            else {
              laborersTotal += workerAllocation.timeInMinutes
            }
          }
        }
      }
      // Compute overall progress for laborers
      const laborersList = this.props.jobInfo.modules.laborers.list
      if (laborersList) {
        for (const laborerId in laborersList) {
          const laborerAllocation = this.props.itemAllocations[laborerId]
          if (laborerAllocation && laborerAllocation.timeInMinutes) {
            laborersTotal += laborerAllocation.timeInMinutes
          }
        }
      }
    }
    return { foremansTotal, laborersTotal }
  }

  render() {
    const item = this.props.item
    const { foremansTotal, laborersTotal } = this.getProgress()
    const totalTarget = 60 * (item.foremansTarget + item.laborersTarget)
    const percent = totalTarget > 0 && foremansTotal + laborersTotal > 0
      ? 100 * (foremansTotal + laborersTotal) / totalTarget
      : null
    const percentDisplay = percent ? `${percent.toFixed(1)}%` : null
    return (
      this.state.edit
        ? <TableRow style={styles.row(this.props.index)}>
          <TableRowColumn colSpan={7}>
            <AddLineItem
              style={styles.editItem}
              editMode={true}
              name={item.name}
              foremansTarget={item.foremansTarget}
              laborersTarget={item.laborersTarget}
              onAddCancelled={this.handleAddCancelled}
              onItemChange={this.handleItemEdited}
              onItemDelete={this.handleItemDelete} />
          </TableRowColumn>
        </TableRow>
        : <TableRow style={styles.row(this.props.index)}>
          <TableRowColumn colSpan={2} style={styles.value}>
            <div style={styles.nameValue} onClick={this.handleNameClicked}>{ item.name }</div>
          </TableRowColumn>
          <TableRowColumn style={styles.value}>{ TimeFormatter.toHoursMinutesFormat(item.foremansTarget * 60) }</TableRowColumn>
          <TableRowColumn style={styles.value}>{ TimeFormatter.toHoursMinutesFormat(item.laborersTarget * 60) }</TableRowColumn>
          <TableRowColumn style={styles.value}>
            { TimeFormatter.toHoursMinutesFormat(foremansTotal) }
          </TableRowColumn>
          <TableRowColumn style={styles.value}>
            { TimeFormatter.toHoursMinutesFormat(laborersTotal) }
          </TableRowColumn>
          <TableRowColumn style={styles.value}>
            { percentDisplay }
          </TableRowColumn>)
        </TableRow>
    )
  }

}

const styles = {

  row: (index) => ({
    backgroundColor: index % 2 ? 'rgba(251, 235, 201, 0.15)' : 'rgba(255, 255, 255, 0.01)',
    borderBottom: 'none'
  }),

  editItem: {
    marginBottom: 8
  },

  nameValue: {
    cursor: 'pointer',
    textAlign: 'start'
  },

  value: {
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    color: '#757575',
    textAlign: 'center',
    fontSize: 14,
    paddingLeft: 14,
    paddingRight: 14,
    paddingTop: 6,
    paddingBottom: 6
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/lineItems/LineItem.js